import Metas from "../assets/images/Metas.jpg"
import Scholor from "../assets/images/Scholar.jpg"
import TPC from "../assets/images/TPC_logo.jfif"
const Education = [
    {
        date: "19/11/2020 - 1/06/2024",
        image: TPC,
        event: "Information Technology Student",
        detail: "University Institute of Engineering and Technology, Panjab University, Chandigarh",
        skills: "CGPA: 9.16",
        link: "https://drive.google.com/file/d/1r1wYKgbWqBhchmchS0i9fLrrYJKmY4dO/view?usp=sharing"
      },
      {
        date: "2018 - 2020",
        image: Scholor,
        event:
          "Science - PCM Student",
        detail: "Scholar English Academy(CBSE)",
        skills: "Percentage: 91.6%",
        link: "https://drive.google.com/file/d/1NS82IetR1Md_6qLLiO91gfFm3g7CsfCJ/view?usp=sharing"
      },
      {
        date: "2017 - 2018",
        image: Metas,
        event:
          "Secondary School Student",
        detail: "Metas Adventist School(ICSE)",
        skills: "Percentage: 91.5%",
        link: "https://drive.google.com/file/d/1rSuskgmv_a0N1icDgUOtPQhUVygYLu-A/view?usp=sharing"
      },
];

export default Education